
import { Component, Vue } from 'vue-property-decorator'
import TitlePage from '@/components/atoms/TitlePage.vue'
import TextFrame from '@/components/atoms/TextFrame.vue'
import PanelFrame from '@/components/molecules/PanelFrame.vue'

/**
 * メールアドレス更新時のメッセージ表示画面レイアウト
 */
@Component({
  components: {
    TitlePage,
    TextFrame,
    PanelFrame,
  },
})
export default class ReconfigureMailMessage extends Vue {}
